import Vue from 'vue'
import Vuex from 'vuex'
import dataStatus from "@/store/dataStatus";
import right from '@/store/right'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        reminders: [],
        mSignData: null
    },
    modules: {
        dataStatus,
        right
    },
    mutations: {
        addReminder(state, reminder) {
            state.reminders.push(reminder);
        },
        setReminders(state, reminders) {
            state.reminders = reminders;
        },
        updateReminder(state, updatedReminder) {
            const index = state.reminders.findIndex(reminder => reminder.id === updatedReminder.id);
            if (index !== -1) {
                Vue.set(state.reminders, index, updatedReminder);
            }
        },
        removeReminder(state, reminderId) {
            state.reminders = state.reminders.filter(reminder => reminder.id !== reminderId);
        },
        setMSignData(state, data) {
            state.mSignData = data
        }
    },
    actions: {
        async fetchReminders({ commit }, userId) {
            // 从后端 API 获取提醒事项
            try {
                // const response = await axios.get(`/api/reminders/${userId}`);
                // commit('setReminders', response.data);
            } catch (error) {
                console.log(error);
            }
        },
        async addReminder({ commit }, reminder) {
            // 向后端 API 添加提醒事项
            try {
                // const response = await axios.post('/api/reminders', reminder);
                // commit('addReminder', response.data);
            } catch (error) {
                console.log(error);
            }
        },
        async updateReminder({ commit }, reminder) {
            try {
                // const response = await axios.put(`/api/reminders/${reminder.id}`, reminder);
                // commit('updateReminder', response.data);
            } catch (error) {
                console.log(error);
            }
        },
        async removeReminder({ commit }, reminderId) {
            try {
                // await axios.delete(`/api/reminders/${reminderId}`);
                // commit('removeReminder', reminderId);
            } catch (error) {
                console.log(error);
            }
        }
    }
})
